import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import { format } from '../../../../../common/services/common.service';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const BppGatewayBasicInfoComponent = ({
    selectedEdgeGateway,
    onInnerBasicFormChange,
    onFormChange
}: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                        <InputContainer
                            label="Type"
                            name="Type"
                            onValueChange={(event: any) => {
                            onInnerBasicFormChange(event.target.value, 'Type');
                            }}
                            type="text"
                            value={selectedEdgeGateway?.Type}
                        />
                    </div>
                    <div>
                        <InputContainer
                            label="Status"
                            labelField="Status"
                            list={[{Id: 1, Status: 'SUBSCRIBED'}]}
                            isRequired={true}
                            isErrored={false}
                            onValueChange={(newValue: any) => {
                            const categoryData: any = newValue.map(
                                (option: any) => option?.value || '',
                            );
                            onFormChange({
                                value: categoryData,
                                field: 'Status',

                                data: selectedEdgeGateway?.Status,
                            });
                            }}
                            type="multiselect"
                            valueField="Id"
                            value={selectedEdgeGateway?.ProductInfo?.CategoryIds}
                        />
                    </div>
                    <div>
                    <InputContainer
                            label="Domains"
                            labelField="Domains"
                            list={[{Id: 1, Domains: 'ONDC:RET10'},{Id: 2, Domains: 'ONDC:RET12'}]}
                            isRequired={true}
                            isErrored={false}
                            onValueChange={(newValue: any) => {
                            const categoryData: any = newValue.map(
                                (option: any) => option?.value || '',
                            );
                            onFormChange({
                                value: categoryData,
                                field: 'Domains',

                                data: selectedEdgeGateway?.Domains,
                            });
                            }}
                            type="multiselect"
                            valueField="Id"
                            value={selectedEdgeGateway?.ProductInfo?.CategoryIds}
                        />
                    </div>

                    <div>
                    <InputContainer
                        isDateTimePicker
                        label="Valid From"
                        name="ValidFrom"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(event.target.value, 'ValidFrom');
                        }}
                        type="date"
                        value={selectedEdgeGateway?.ValidFrom}
                    />
           
                    </div>
                    <div>
                        <InputContainer
                            isDateTimePicker
                            label="Valid Until"
                            name="ValidUntil"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(event.target.value, 'ValidUntil');
                            }}
                            type="date"
                            value={selectedEdgeGateway?.ValidUntil}
                        />
                    </div>
                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    </>
)
export default BppGatewayBasicInfoComponent;
